<template>
  <div class="to-retain" v-if="bindShow" @click="bindShow = false">
    <div class="operate-wrap">
      <KaerImage :src="require('@/assets/close.png')" />
    </div>
    <div class="poster-wrap" @click.stop>
      <KaerImage :src="props.toRetain" />
      <div class="btn-hover" @click="openShare"></div>
      <div class="confirm-back" @click="nativeBack">忍痛离开</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import KaerImage from '@/components/image';
import bindShow from '@/mixins/bindShow';

export default {
  props: {
    props: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    KaerImage
  },
  mixins: [
    bindShow
  ],
  computed: {
    ...mapState({
      homeInfo: state => state.share.homeInfo
    })
  },
  methods: {
    async openShare() {
      this.uploadData(this.$teleCodes.clickInvite, 'event');
      // 根据是否存在邀请人信息判断是否登录
      if (!this.homeInfo.inviterUserId) {
        await this.adapt.reLogin();
        return;
      }
      this.bindShow = false;
      this.$bus.$emit('openShareDialog');
    },
    nativeBack() {
      this.bindShow = false;
      this.$goBack();
    }
  }
};
</script>

<style lang="less" scoped>
.to-retain {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 28px;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;

  .operate-wrap {
    width: 24px;
    height: 24px;
    align-self: flex-end;
    margin-right: 24px;
  }

  .poster-wrap {
    width: 282px;
    position: relative;

    .btn-hover {
      position: absolute;
      bottom: 75px;
      left: 50%;
      transform: translateX(-50%);
      width: 75%;
      height: 50px;
    }

    .confirm-back {
      position: absolute;
      padding: 15px 35px 25px;
      bottom: 15px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 14px;
    }
  }

}
</style>
